// import Vue from 'vue'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

// import Vue from 'vue'
// import App from './App'
// import router from './router'
// // import iView from 'iview'
// // import mavonEditor from 'mavon-editor'
// // import { component } from 'vue/types/umd'

// // Vue.use(iView)
// // Vue.use(mavonEditor)
// new Vue({
//   el: '#app',
//   router,
//   components:{ App},
//   template:'<App/>'
// });

import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import VueI18n from 'vue-i18n';
import messages from '@/lang';
import store from './store';
// eslint-disable-next-line
// import axios from 'axios'
// import router from './router'
// import echarts from 'echarts'
// import mockInit from './mock/mock.js'

Vue.config.productionTip = false

Vue.use(VideoPlayer)
Vue.use(VueI18n);
Vue.use(ElementUI,{locale});


const i18n = new VueI18n({
  locale: localStorage.getItem('selectedLanguage') || 'zh',
  messages, // Provide the imported language files
});
// Vue.prototype.$echarts = echarts
// axios.defaults.baseURL = '/proxy_url'
Vue.prototype.$eventBus = new Vue();
new Vue({
  i18n,
  el: '#app',
  store,
  render: h => h(App),
});




// mockInit()

// import Vue from 'vue'
// import routes from './routes'

// const app = new Vue({
//   el: '#app',
//   data: {
//     currentRoute: window.location.pathname
//   },
//   computed: {
//     ViewComponent () {
//       const matchingView = routes[this.currentRoute]
//       return matchingView
//         ? require('./pages/' + matchingView + '.vue')
//         : require('./pages/404.vue')
//     }
//   },
//   render (h) {
//     return h(this.ViewComponent)
//   }
// })

// window.addEventListener('popstate', () => {
//   app.currentRoute = window.location.pathname
// })

